import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "@/lib/cn";

const sizes = {
  36: "size-9 text-xs",
  48: "size-12 text-sm",
  72: "size-[4.5rem] text-xl",
  96: "size-24 text-2xl",
} as const;

type AvatarProps = {
  alt?: string;
  fallback: string;
  size?: keyof typeof sizes;
  src?: string | null | undefined;
  version?: string | undefined;
  onImageError?: (version?: string) => void;
  className?: string;
};

export function Avatar({
  alt,
  fallback,
  size = 36,
  src,
  version,
  onImageError,
  className,
}: AvatarProps) {
  return (
    <AvatarPrimitive.Root
      className={cn(
        "grid shrink-0 place-items-center overflow-hidden rounded-full bg-primary font-semibold leading-none text-white",
        sizes[size],
        className,
      )}
    >
      {src && (
        <AvatarPrimitive.Image
          alt={alt ?? ""}
          className="size-full object-cover"
          key={version ?? src}
          onLoadingStatusChange={(status) => {
            if (status === "error") onImageError?.(version);
          }}
          src={src}
        />
      )}
      <AvatarPrimitive.Fallback className="grid size-full place-items-center">
        {fallback}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
